

export enum BankCardsState {
    Overview,
    Transactions
}

export enum ProfileState {
    Info,
    Companies,
    Account,
    ConnectedAccounts,
    BankAccounts
}

export enum DashboardsState {
    DashboardsHome
}

export enum GroupDashboardsState {
    DashboardsAccountbalance,
    DashboardsFunds,
    BankAccounts
}

export enum SettingsState {
    ConnectedAccounts,
    BankAccounts
}

export enum DataRoomState {
    None = 0,
    Reports = 1 << 0,
    Files = 1 << 1,
    Tags = 1 << 2,
}

export enum SetupState {
    CompanyInfo,
    ConnectedAccounts,
    Team,
    Integration
}

export enum AddonsState {
    All,
    AddOns,
    Api,
    Payments,
    Accounting,
    Uploaders,
    ArAp,
    Rading
}

/**
 * Steps of the bank-connection wizard, in order. The numbering is load-bearing: changeStep() walks
 * it with `activeStep++/--`, and the values are serialised into `?step=` deep links.
 */
export enum BankAccountsState {
    CountrySelection = 0,
    ChooseConnectionType = 1,
    SetDate = 2,
    ChooseBank = 3,
    ConnectToBank = 4,
    ChooseAccounts = 5,
    SyncTransactions = 6
}

export enum TRANSACTIONS_TABS {
    TRANSACTIONS_NEW,
    TRANSACTIONS_MAPPED,
    TRANSACTIONS_CATEGORIES,
    TRANSACTIONS_RULES,
    TRANSACTIONS_AI_RULES
}

/** @deprecated Use TRANSACTIONS_TABS — kept for release/6.5.0 callers */
export enum TransactionsState {
    TransactionsNew = TRANSACTIONS_TABS.TRANSACTIONS_NEW,
    TransactionsMapped = TRANSACTIONS_TABS.TRANSACTIONS_MAPPED,
    TransactionsCategories = TRANSACTIONS_TABS.TRANSACTIONS_CATEGORIES,
    Rules = TRANSACTIONS_TABS.TRANSACTIONS_RULES,
}

export enum CompanyReceivablesState {
    Overview,
    Invoices,
    Contracts,
    Matching,
    Rules
}

export enum GroupReceivablesState {
    Invoices
}

export enum InvoiceSubTab {
    Opened,
    Receivables,
    Payables,
    Paid,
    Cancelled,
    All
}

export enum ContractsState {
    Contracts,
    Loans,
    Financing,
    BudgetRules,
    OtherContracts
}

export enum Reporting {
    Reporting,
    Savedreports
}

export enum InsightsState {
    AIForecastTab,
    OutlookTab,
    CashBurnTab,
    ActualsTab,
    DeviationsTab,
    DetailsTab
}

export enum PayablesState {
    Payables,
    Counterparts,
    PaymentRun,
    ApprovalPolicies,
    Tags
}

export enum PayablesListState {
    Verify,
    InApproval,
    ToBePaid,
    InPayment,
    Open,
    Paid,
    Cancelled,
    Exported,
    Approvals,
    All
}
export enum ReceivablesState {
    Receivables,
    Counterparts
}
